import { render, staticRenderFns } from "./CreateDns.vue?vue&type=template&id=06bbb498&"
import script from "./CreateDns.vue?vue&type=script&lang=ts&"
export * from "./CreateDns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports